import React, { Component } from 'react'
import Request from 'config/Request.js'
import { css } from 'glamor'
import Lottie from 'react-lottie';
import * as animationData from 'component/animation/newAnimation.json'

const VERSION_KEY = 'version'

const defaultOptions = {
  loop: true,
  autoplay: true, 
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice'
  }
};

let backdrop = css({
  background: 'rgba(0, 0, 0, 0.65)',
  zIndex: '9999999',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  position: 'fixed',
})


let box = css({
  display: 'flex',
  position: 'fixed',
  background: 'white',
  top: '20%',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  borderRadius: '8px',
})

let btnStyle = css({
  marginTop: '1rem',
  marginBottom: '3rem',
  borderRadius: '4px',
})

export default class CheckVersion extends Component {
  constructor() {
    super()

    this.state = {
      showScreen: false,
      version: null
    }
  }
  

  onLoad = () => {
    Request(
      'get',
      'check-version',
      {},
      {},
      [],
      this.onLoadSuccess,
      this.onLoadFailed,
    )
  }

  onLoadSuccess = (response) => {
    let server_version = response.data.version
    let local_version = localStorage.getItem(VERSION_KEY)
    
    let show = false

    if(local_version){
      if(server_version !== Number(local_version)) {
        show = true
      }
    }else{
      localStorage.setItem(VERSION_KEY, server_version)
    }

    this.setState({
      showScreen: show,
      version: server_version
    })
    console.log('ATM CLOUD v.' + local_version)
  }

  onLoadFailed = () => {
    this.setState({
      showScreen: false
    })
  }

  onLogout = () => {
    localStorage.removeItem('AuthenticationToken')
    localStorage.setItem(VERSION_KEY, this.state.version)
    window.location.reload()

  }

  componentDidMount = () => {
    this.onLoad()
  }
  

  render() {
    const {showScreen} = this.state

    if(showScreen) {
      return (
          <div {...backdrop}>
            <div {...box} className="col-sm-6 offset-sm-3">  
              <Lottie 
                options={defaultOptions}
                height={250}
                width={250}
              />
              <h3 className="text-center">We have a new update</h3>
              <p className="text-center">please logout and re-login to your account.</p>
              <button onClick={()=>this.onLogout()} {...btnStyle} className="btn btn-primary">OK, Logout</button>
          </div>
        </div>
      )
    } else {
      return null
    }
  }
}



// WEBPACK FOOTER //
// ./src/App/component/CheckVersion.js